import { useQuery, UseQueryOptions } from 'react-query';
import { QueryKeys } from '.';
import { useApi } from '../../context';
import { NaicsCode } from '../../models';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useNaicsCodeQuery(
	search?: string,
	options?: Omit<UseQueryOptions<NaicsCode[], unknown, NaicsCode[], string[]>, 'queryKey' | 'queryFn'>
) {
	const api = useApi();
	return useQuery(
		QueryKeys.Lookups.NaicsCodes(search),
		() => AxiosUtils.getResponseData<NaicsCode[]>(api.get(CerebroApiEndpoints.Lookups.NaicsCodes(search))),
		options
	);
}
